'use client';

import type { ClassValue } from 'clsx';
import type { ChangeEvent } from 'react';

import { useAtomSet, useAtomValue } from '@effect/atom-react';
import { IndexSearchField, IndexSearchFieldClear } from '@vs-shop/commerce-ui/indexSearchField';
import { Input } from '@vs-shop/ui/input';
import { clsxm } from '@vs-shop/utils';
import { X } from 'lucide-react';
import { useIntl } from 'react-intl';

import {
  glossaryFilterActionFn,
  glossarySearchDraftAtom,
} from '../../../../effect/atom/glossary/glossarySearchInput';

type Props = {
  className?: ClassValue;
};

export function GlossarySearchInput({ className }: Props) {
  const intl = useIntl();

  const value = useAtomValue(glossarySearchDraftAtom);
  const dispatch = useAtomSet(glossaryFilterActionFn, { mode: 'promise' });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    void dispatch({ _tag: 'Type', value: e.target.value });
  };

  const handleClear = () => {
    void dispatch({ _tag: 'Clear' });
  };

  return (
    <IndexSearchField className={clsxm(className)}>
      <Input
        id="glossary-search"
        value={value}
        onChange={handleChange}
        label={intl.formatMessage({
          id: 'container.glossary.search.input.placeholder',
          defaultMessage: 'Nebo můžete pojem vyhledat',
        })}
      />
      {value.length > 0 && (
        <IndexSearchFieldClear
          className="right-2 flex size-11 items-center justify-center rounded-xs focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
          onClick={handleClear}
          aria-label={intl.formatMessage({
            id: 'container.glossary.search.input.clear',
            defaultMessage: 'Vymazat hledání',
          })}
        >
          <X className="w-4" />
        </IndexSearchFieldClear>
      )}
    </IndexSearchField>
  );
}
